import { XMLParser } from 'fast-xml-parser';

interface FieldPath {
  path: string;
  isArray: boolean;
  value: any;
}

function extractFieldPaths(
  obj: any,
  prefix = '',
  paths: FieldPath[] = []
): FieldPath[] {
  if (obj === null || obj === undefined) {
    return paths
  }

  const isArray = Array.isArray(obj);
  const arrayNoItem = isArray && obj.length === 0;
  const isObject = typeof obj === 'object';

  if (arrayNoItem) {
    return paths
  }

  if (isArray) {
    const arrayPrefix = prefix ? `${prefix}[0]` : '[0]';
    return extractFieldPaths(obj[0], arrayPrefix, paths);
  }

  if (!isObject) {
    const isArrayPath = prefix.includes('[0]');
    paths.push({
      path: prefix,
      isArray: isArrayPath,
      value: obj,
    })
    return paths
  }

  for (const [key, value] of Object.entries(obj)) {
    const currentPath = prefix ? `${prefix}.${key}` : key;

    if (value === null || value === undefined) {
      continue;
    }

    const valueIsArray = Array.isArray(value);
    if (valueIsArray) {
      const arrayPath = `${currentPath}[0]`;
      extractFieldPaths(value[0], arrayPath, paths);
    } else {
      extractFieldPaths(value, currentPath, paths);
    }
  }

  return paths;
}

export function parseXml(xmlString: string): any {
  try {
    const parser = new XMLParser({
      ignoreAttributes: false,
      attributeNamePrefix: '',
      textNodeName: '_text',
      parseAttributeValue: false,
      trimValues: true,
    });

    const result = parser.parse(xmlString);

    if (!result || typeof result !== 'object') {
      throw new Error('XML document has no valid structure');
    }

    return result;
  } catch (error) {
    throw new Error(
      `Failed to parse XML: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`
    );
  }
}

export function extractXmlFieldPaths(xmlString: string): FieldPath[] {
  try {
    const parsed = parseXml(xmlString);
    const paths = extractFieldPaths(parsed);
    return paths.sort((a, b) => a.path.localeCompare(b.path));
  } catch (error) {
    throw error;
  }
}

export type { FieldPath };
